import React from 'react'
import PdfReportsHeader from 'routes/App/Apps/PdfReports/PdfReportsHeader'
import { StyledTableApp } from 'styles/app/apps/main-style'
import PdfReportsTable from 'routes/App/Apps/PdfReports/PdfReportsTable'
import { connect } from 'react-redux'
import Psfs from 'lib/psfs/Psfs'
import {
  fetchPdfReportsTableData,
  setTablePsfs,
} from 'reducers/pdfReports/reducer'

type PdfReportsProp = {
  currentApp: { name: string }
  history: {
    goBack: () => void
  }
  fetchPdfReportsTableData: (psfs: Psfs) => {}
  setTablePsfs: (psfs: Psfs) => {}
}

const PdfReports = ({
  currentApp: { name: appName },
  history: { goBack },
  setTablePsfs,
  fetchPdfReportsTableData,
}: PdfReportsProp) => {
  const fetchPdfReportData = (psfs: Psfs): void => {
    setTablePsfs(psfs)
    fetchPdfReportsTableData(psfs)
  }

  return (
    <StyledTableApp direction="column">
      <PdfReportsHeader
        appName={appName}
        goBack={goBack}
        fetchPdfReportData={fetchPdfReportData}
      />
      <PdfReportsTable fetchPdfReportData={fetchPdfReportData} />
    </StyledTableApp>
  )
}

export default connect(() => ({}), {
  fetchPdfReportsTableData,
  setTablePsfs,
})(PdfReports)
